import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { Action, createReducer, on } from '@ngrx/store';

import {
  addToHistoryFailure,
  addToHistorySuccess,
  loadUserHistoryFailure,
  loadUserHistorySuccess,
} from './history.actions';
import { UserHistoryEntry } from './history.models';

export const USER_HISTORY_FEATURE_KEY = 'userHistory';

export interface UserHistoryState extends EntityState<UserHistoryEntry> {
  loaded: boolean;
  error?: string | null;
}

export interface UserHistoryPartialState {
  readonly [USER_HISTORY_FEATURE_KEY]: UserHistoryState;
}

export function selectUserHistoryEntryId(entry: UserHistoryEntry) {
  return `${entry.entityType}/${entry.id}`;
}

export const userHistoryAdapter: EntityAdapter<UserHistoryEntry> = createEntityAdapter<UserHistoryEntry>({
  selectId: selectUserHistoryEntryId,
});

export const { selectAll } = userHistoryAdapter.getSelectors();

export const initialUserHistoryState: UserHistoryState = userHistoryAdapter.getInitialState({ loaded: false });

const reducer = createReducer(
  initialUserHistoryState,
  on(loadUserHistorySuccess, (state, { entries }) => userHistoryAdapter.setAll(entries, { ...state, loaded: true })),
  on(addToHistorySuccess, (state, { entry }) => userHistoryAdapter.setAll([entry, ...selectAll(state)], state)),
  on(loadUserHistoryFailure, addToHistoryFailure, (state, { error }) => ({ ...state, error }))
);

export function userHistoryReducer(state: UserHistoryState | undefined, action: Action) {
  return reducer(state, action);
}
